import { Tab } from '@gerdau/hefesto';
import React, { useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import HelpManuals from './HelpManuals';
import { EHelpCenterRoutes, HelpCenterRoutes } from './helpCenter.routes';
import { Container } from './styles';

export const HelpCenter: React.FC = () => {
  const [activeKey, setActiveKey] = useState(
    EHelpCenterRoutes.COMMON_QUESTIONS
  );

  const { path } = useRouteMatch();
  const history = useHistory();
  const { pathname } = history.location;

  const onTabClick = (tab: string) => {
    history.push(`${path}${tab}`);
    setActiveKey(tab as EHelpCenterRoutes);
  };

  useEffect(() => {
    if (pathname.includes(EHelpCenterRoutes.COMMON_QUESTIONS)) {
      return setActiveKey(EHelpCenterRoutes.COMMON_QUESTIONS);
    }
    if (pathname.includes(EHelpCenterRoutes.HELP_MANUALS)) {
      return setActiveKey(EHelpCenterRoutes.HELP_MANUALS);
    }

    setActiveKey(EHelpCenterRoutes.CONTACT);
  }, [pathname]);

  const getTabs = () => {
    const tabs = [
      {
        key: EHelpCenterRoutes.CONTACT,
        content: <HelpCenterRoutes />,
        name: 'Entrar em contato'
      },
      {
        key: EHelpCenterRoutes.COMMON_QUESTIONS,
        content: <HelpCenterRoutes />,
        name: 'Perguntas frequentes'
      }
    ];

    tabs.unshift({
      key: EHelpCenterRoutes.HELP_MANUALS,
      content: <HelpManuals />,
      name: 'Manuais de ajuda'
    });

    tabs.unshift();

    return tabs;
  };

  return (
    <Container>
      <Tab
        tabPosition="left"
        tabItems={getTabs()}
        activeKey={activeKey}
        onChange={onTabClick}
      ></Tab>
    </Container>
  );
};
